import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import { Button, Input, Icon, Typography, Dropdown, Menu, Tooltip, message } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { platformApi } from "../../../api";
import StateTable from "./StateTable";
import StateForm from "./StateForm";
import { ContextAPI } from "../../../ContextAPI";

const { Search } = Input;
const { Title } = Typography;
const { Item } = Menu;

const State = (props) => {
  const { loginCredintials } = useContext(ContextAPI);
  const [createAccess, setCreateAccess] = useState(true);
  const [modifyAccess, setModifyAccess] = useState(true);

  const [searchString, setSearchString] = useState("");
  const [states, setStates] = useState([]);
  const [count, setCount] = useState(0);
  const [spinner, setSpinner] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editable, setEditable] = useState(true);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  const getMenu = () => {
    let size = count / 10 + (count % 10 ? 1 : 0);
    const menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item onClick={() => { setLimit(menu); setPage(1); }} key={menu}>
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  useEffect(() => {
    if (loginCredintials && loginCredintials.roleAccess) {
      loginCredintials.roleAccess.forEach((each) => {
        if (each.subModule === "state") {
          if (each.access && each.access.create !== undefined) {
            setCreateAccess(each.access.create);
          }
          if (each.access && each.access.update !== undefined) {
            setModifyAccess(each.access.update);
          }
        }
      });
    }
  }, [loginCredintials]);

  useEffect(() => {
    fetchStates(page, limit, searchString);
  }, [page, limit, searchString]);

  const fetchStates = (p, l, search) => {
    setSpinner(true);
    platformApi
      .post("/api/csc/state/get", {
        page: p,
        size: l,
        searchString: search,
      })
      .then((res) => {
        setSpinner(false);
        const { data } = res;
        if (data.code === 200) {
          const { response } = data;
          if (response && response.code === 200 && response.data) {
            setStates(response.data.states || []);
            setCount(response.data.count || 0);
          }
        }
      })
      .catch((err) => {
        setSpinner(false);
        console.error("Error fetching states:", err);
        message.error("Failed to fetch states");
      });
  };

  const openModal = (id, isEditable = true) => {
    if (id) {
      const selected = states.find((item) => item.id === id);
      setCurrentRecord(selected || null);
    } else {
      setCurrentRecord(null);
    }
    setEditable(isEditable);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentRecord(null);
  };

  const emitData = (payload) => {
    if (payload.id) {
      platformApi
        .put(`/api/csc/state/${payload.id}`, payload)
        .then((res) => {
          if (res.data && res.data.code === 200) {
            message.success("State updated successfully");
            fetchStates(page, limit, searchString);
          } else {
            message.error(res.data?.message || "Failed to update state");
          }
        })
        .catch((err) => {
          console.error("Error updating state:", err);
          message.error("Error updating state");
        });
    } else {
      platformApi
        .post("/api/csc/state", payload)
        .then((res) => {
          if (res.data && res.data.code === 200) {
            message.success("State created successfully");
            setPage(1);
            fetchStates(1, limit, searchString);
          } else {
            message.error(res.data?.message || "Failed to create state");
          }
        })
        .catch((err) => {
          console.error("Error creating state:", err);
          message.error("Error creating state");
        });
    }
  };

  const deleteData = (id) => {
    let temp = page !== 1 && states.length === 1;
    platformApi
      .delete(`/api/csc/state/${id}`)
      .then((res) => {
        if (res.data && res.data.code === 200) {
          message.success("State deleted successfully");
          if (temp) {
            setPage(1);
            fetchStates(1, limit, searchString);
          } else {
            fetchStates(page, limit, searchString);
          }
        } else {
          message.error(res.data?.message || "Failed to delete state");
        }
      })
      .catch((err) => {
        console.error("Error deleting state:", err);
        message.error("Error deleting state");
      });
  };

  return (
    <div>
      <div className="supplierMaster-top" style={{ display: "flex", alignItems: "center", marginBottom: "1.25rem" }}>
        <Title style={{ width: "60%" }} level={4}>
          <Tooltip placement="topLeft" title={"Back to Company Master"}>
            <Button
              style={{ margin: "0 20px" }}
              onClick={() => props.history.push("/autoadmin/company")}
            >
              <LeftOutlined />
            </Button>
          </Tooltip>
          State Master[{count}]
          <span style={{ marginLeft: "1rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit}
                &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          placeholder="Search State"
          style={{ width: "30%" }}
          onSearch={(event) => {
            setPage(1);
            setSearchString(event);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearchString("");
              setPage(1);
            }
          }}
        />
        <Button
          type="primary"
          className="add-manufacturer-button"
          onClick={() => openModal(null, true)}
          style={{ margin: "0 3%", width: "14%" }}
          disabled={!createAccess}
        >
          Add State
        </Button>
      </div>

      <div style={{ margin: ".5rem" }}>
        <StateTable
          dataSource={states}
          spinner={spinner}
          pagination={{
            onChange: (p) => {
              setPage(p);
            },
            pageSize: limit,
            defaultCurrent: 1,
            total: count,
            current: page,
            showQuickJumper: true,
          }}
          openModal={openModal}
          delete={deleteData}
        />
      </div>

      <StateForm
        open={isModalOpen}
        close={closeModal}
        data={currentRecord}
        editable={editable}
        modify={modifyAccess}
        emitData={emitData}
      />
    </div>
  );
};

export default withRouter(State);
